// extracted by mini-css-extract-plugin
export default {"summary":"pcWpK","appear-from-above":"cGCG0","appearFromAbove":"cGCG0"};